import { render, staticRenderFns } from "./VideoThumbnail.vue?vue&type=template&id=77d506c6&"
import script from "./VideoThumbnail.vue?vue&type=script&lang=js&"
export * from "./VideoThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./VideoThumbnail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77d506c6')) {
      api.createRecord('77d506c6', component.options)
    } else {
      api.reload('77d506c6', component.options)
    }
    module.hot.accept("./VideoThumbnail.vue?vue&type=template&id=77d506c6&", function () {
      api.rerender('77d506c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/designed/user/components/VideoThumbnail.vue"
export default component.exports